import { NavLink } from 'react-router-dom'
import { INSIGHTS_NAV } from './insightsNavItems'
import styles from './InsightsTabBar.module.css'

// Mobile bottom tab bar of the insights section (design): fixed on phones,
// hidden from tablet width up — desktop sidebar covers navigation there.
export default function InsightsTabBar() {
  return (
    <nav className={styles.bar} aria-label="Инсайты">
      {INSIGHTS_NAV.map((item) => {
        const Icon = item.Icon
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `${styles.item} ${isActive ? styles.active : ''}`}
          >
            <Icon className={styles.icon} size={24} stroke={1.75} />
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        )
      })}
    </nav>
  )
}
